<div class="image-slider" [ngClass]="{'container': !isMobile}">
  <div *ngIf="fundraiser?.beneficiary?.tax_benefit" class="tax_exempt">
    <div class="taxContainer">
      <span class="taxRibbon" *ngIf="isMobile">
        <img loading="lazy" data-src="/assets/images/tax.svg" alt="Tax Benefit Ribbon" src="/assets/images/transparent.png">
      </span>
      <div class="tax-benefit" *ngIf="!isMobile">
        <div class="taxt-container">
          <img loading="lazy" data-src="/assets/images/tax.svg" alt="Tax benefit ribbon"/>
        </div>
      </div>
    </div>
    <span class="tooltipText">80G Tax Exemption Certificate Available</span>
  </div>
  <div class="days-left" [hidden]="utilService.isMobile() && vwo.story_variation_1() && !hasUserDonated" *ngIf="fundraiser?.end_date && !isFundraiserEnded && !fundraiser?.settings?.hidedaysleft">
    <span>
      <i class="icon-stopwatch icomoon"></i>{{+(fundraiser?.end_date | dayjs:'diffInDays')}} {{+(fundraiser?.end_date | dayjs:'diffInDays') <= 1 ? 'Day' : 'Days'}} Left
    </span>
  </div>
  <div *ngIf="fundraiser?.video_appeal" class="watch-appeal" [ngClass]="{'watch-appeal-pos': !fundraiser?.hospital?.info_1}">
    <button (click)="scrollToVideo()" mat-button><span><i class="material-icons">play_circle_filled</i>Watch Appeal</span></button>
  </div>
  <div *ngIf="fundraiser?.gallery?.length <= 1">
    <img loading="lazy" class="threatre-img" [ngClass]="{'variation2': vwo.story_variation_2()}" [attr.data-src]="getTheaterImage()" [default]="utilService.defaultImg" alt="{{fundraiser?.story_title?.info_1}}" />
    <div class="banner-overlay" [ngClass]="{'variation2': vwo.story_variation_2()}">
      <h3 *ngIf="fundraiser?.story_title && !vwo.story_variation_2()" class="story_title" [innerHTML]="fundraiser?.story_title?.info_1 | safeHtml"></h3>
      <h3 *ngIf="!fundraiser?.story_title && !vwo.story_variation_2()" class="story_title" [innerHTML]="fundraiser?.title | safeHtml"></h3>
      <div class="story-title-wrapper" *ngIf="vwo.story_variation_2()">
        <h3 *ngIf="fundraiser?.story_title" class="story_title" [innerHTML]="fundraiser?.story_title?.info_1 | safeHtml"></h3>
      </div>
    </div>
  </div>
  <div *ngIf="fundraiser?.gallery?.length > 1">
    <app-story-img-slider *ngIf="fundraiser" [fundraiser]="fundraiser" [gallery]="fundraiser?.gallery" [basicInfo]="fundraiser?.basicinfo" slideType="leaderboard" [shadow]="false"></app-story-img-slider>
  </div>
</div>
